import { Injectable } from '@angular/core';
import {MvpHttpClient} from "../../../mvp-auth";
import {BaseHttpServiceAbstract} from "./BaseHttpService.abstract";
import { HttpParams } from "@angular/common/http";
import { instance } from "@viz-js/viz";

@Injectable({
  providedIn: 'root'
})
export class DmsWorkflowDigraph extends BaseHttpServiceAbstract{

  constructor( http: MvpHttpClient ) { super(http); }

  readDmsWorkflowDigraph$(id: number, isWorkflowId?: boolean){
    let params: HttpParams = new HttpParams();
    if(isWorkflowId){
      params = params.append("workflowId", id);
    } else {
      params = params.append("templateId", id);
    }
    return this.read$<any>(`workflow/digraph`, params)
  }

  openDiagram(id: number, isWorkflowId?: boolean) {
    this.readDmsWorkflowDigraph$(id, isWorkflowId).subscribe( response => {
      if (response.result) {
        const originalDOT = response.result.digraph;
        let cleanedDot = originalDOT;
        // Remove surrounding quotes if present
        if (cleanedDot.startsWith('"') && cleanedDot.endsWith('"')) {
          cleanedDot = cleanedDot.slice(1, -1);
        }
        // Unescape basic characters
        cleanedDot = cleanedDot
          .replace(/\\"/g, '"')
          .replace(/\\r\\n/g, '\n')
          .replace(/\\n/g, '\n')
          .replace(/\\t/g, '\t')
          .replace(/\\\\/g, '\\');
        // Decode Unicode escapes
        cleanedDot = cleanedDot.replace(/\\u([0-9a-fA-F]{4})/g, (match: any, hex: any) => {
          return String.fromCharCode(parseInt(hex, 16));
        });
        // Then convert it to SVG with Viz library
        instance().then(viz => {
          const svgContent = viz.renderSVGElement(cleanedDot);
          this.openSvgInNewWindow(svgContent);
        }).catch((error: any) => {
          console.error('Error initializing Viz.js with cleaned DOT:', error);
        });
      }
    });
  }

  openSvgInNewWindow(svgContent: SVGSVGElement): void {

    const title = 'Diagram';

    const width = 800;
    const height = 600;
    const left = (screen.width / 2) - (width / 2);
    const top = (screen.height / 2) - (height / 2);

    const newWindow = window.open(
      '',
      '_blank',
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );

    if (newWindow) {

      newWindow.document.write(`
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${title}</title>
        <style>
          body {
            margin: 0;
            padding: 0;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
            background-color: #f0f0f0;
          }
          .svg-container {
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: auto;
            width: 100%;
            height: 100%;
            background-color: white;
          }
          svg {
            max-width: 100%;
            max-height: 100%;
            transform-origin: center;
            transition: transform 0.2s ease-in-out;
          }
        </style>
      </head>
      <body>
        <div class="svg-container">
          ${svgContent.outerHTML}
        </div>
        <script>
          const svgElement = document.querySelector('svg');
          let isDragging = false;
          let lastX = 0;
          let lastY = 0;
          let scale = 1;
          let translateX = 0;
          let translateY = 0;

          const svgContainer = document.querySelector('.svg-container');
          svgContainer.style.cursor = 'grab';

          svgContainer.addEventListener('pointerdown', (event) => {
            isDragging = true;
            lastX = event.clientX;
            lastY = event.clientY;
            svgContainer.style.cursor = 'grabbing';
          });

          svgContainer.addEventListener('pointermove', (event) => {
            if (!isDragging) return;
            const deltaX = event.clientX - lastX;
            const deltaY = event.clientY - lastY;

            translateX += deltaX;
            translateY += deltaY;

            applyTransform();
            lastX = event.clientX;
            lastY = event.clientY;
          });

          svgContainer.addEventListener('pointerup', () => {
            isDragging = false;
            svgContainer.style.cursor = 'grab';
          });

          svgContainer.addEventListener('wheel', (event) => {
            event.preventDefault();
            const zoomFactor = 0.1;
            scale += event.deltaY < 0 ? zoomFactor : -zoomFactor;
            scale = Math.max(0.5, Math.min(scale, 10));
            applyTransform();
          });

          function applyTransform() {
            if (svgElement) {
              svgElement.style.transform = \`translate(\${translateX}px, \${translateY}px) scale(\${scale})\`;
            }
          }
        </script>
      </body>
      </html>
    `);

      newWindow.document.close();

    }
  }
}
